module.exports = __webpack_public_path__ + "89f5d60a18a0588a91248831eaa15e31.png";